import { AVAILABLE_COUNTRIES, DEFAULT_COUNTRY } from "@func-core/core/domain/constants";

export type Locale = {
  code: string;
  name: string;
  nativeName: string;
};

export type Country = {
  name: string;
  language: Locale;
  prefixPhoneNumber: string;
  currency: string;
  iso: string;
};

export const CountrySource = {
  DEFAULT: "default",
  RESULT: "result",
  URL: "url",
  USER_SELECTION: "user_selection",
} as const;

export type CountrySourceType = typeof CountrySource[keyof typeof CountrySource];

export type CountryDetectionResponse =
  | {
      iso: string;
      source: CountrySourceType;
    }
  | {
      locale: string;
      source: CountrySourceType;
    };

type CountryViewModel = {
  country: Country;
  source: CountrySourceType;
};

export const createCountryViewModel = (detection?: CountryDetectionResponse): CountryViewModel => {
  if (!detection) {
    return {
      country: DEFAULT_COUNTRY,
      source: CountrySource.DEFAULT,
    };
  }

  let detectedCountry: Country | undefined;

  if ("iso" in detection) {
    detectedCountry = Object.values(AVAILABLE_COUNTRIES).find(
      (c) => c.iso.toLowerCase() === detection.iso.toLowerCase()
    );
  } else {
    const [language, country] = detection.locale.split("-");
    const normalizedLocale = country ? `${language}-${country.toUpperCase()}` : language;

    detectedCountry = Object.values(AVAILABLE_COUNTRIES).find(
      (c) => c.language.code.toLowerCase() === normalizedLocale.toLowerCase()
    );
  }

  return {
    country: detectedCountry ?? DEFAULT_COUNTRY,
    source: detection.source,
  };
};
